import getStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    setLastEnterUpNext,
    resetCalendarUpNextState,
    setLastEnterCalendarTab,
    resetHeaderTabDropViewState,
    setLastEnterTasksTab,
    setDayViewDropTimeMinuteOffset,
    setShowDayDropHint,
} from '../actions/timePanelDndStoreActions';
import { createDropViewState } from 'owa-dnd';

mutator(setLastEnterCalendarTab, actionMessage => {
    getStore().lastDragOverCalendarTab = actionMessage.lastTime;
});

mutator(resetHeaderTabDropViewState, actionMessage => {
    switch (actionMessage.nextView) {
        case 'Calendar':
            getStore().calendarTabDropViewState = createDropViewState();
            break;
        case 'Tasks':
            getStore().tasksTabDropViewState = createDropViewState();
            break;
    }
});

mutator(setLastEnterTasksTab, actionMessage => {
    getStore().lastDragOverTasksTab = actionMessage.lastTime;
});

mutator(setLastEnterUpNext, actionMessage => {
    getStore().lastDragOverUpNext = actionMessage.lastTime;
});

mutator(resetCalendarUpNextState, () => {
    getStore().upNextDropViewState = createDropViewState();
});

mutator(setShowDayDropHint, actionMessage => {
    getStore().shouldShowHoverDayDrop = actionMessage.shouldShow;
});

mutator(setDayViewDropTimeMinuteOffset, ({ dayViewDropTimeMinuteOffset }) => {
    getStore().dayViewDropTimeMinuteOffset = dayViewDropTimeMinuteOffset;
});
